import * as _ from "lodash";
import * as angular from "angular";

let RecurringDateRangeComponent = {
    selector: "vcRecurringDateRange",
    templateUrl:
        "/angular/components/event/dates/recurring-date-range.component.html",
    bindings: {
        recurring: "=?",
    },
    controller: class RecurringDateRangeController {
        // * bindings for typescript compiler *
        public recurring?: any;
        // ************************************

        private preferencesService: any;
        public use24hr: boolean = false;
        public periods: string[];
        public hours: number[];
        public readonly minutes = ["00", 15, 30, 45];
        public readonly days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        public readonly months = [
            { num: 0, name: "January" },
            { num: 1, name: "February" },
            { num: 2, name: "March" },
            { num: 3, name: "April" },
            { num: 4, name: "May" },
            { num: 5, name: "June" },
            { num: 6, name: "July" },
            { num: 7, name: "August" },
            { num: 8, name: "September" },
            { num: 9, name: "October" },
            { num: 10, name: "November" },
            { num: 11, name: "December" },
        ];

        constructor(PreferencesService: any) {
            this.preferencesService = PreferencesService;
            this.use24hr = PreferencesService.use24Hour();
            this.periods = this.use24hr ? [""] : ["am", "pm"];
            this.hours = this.use24hr
                ? [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                      17, 18, 19, 20, 21, 22, 23,
                  ]
                : [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        }

        formatTimeOption(hour: number, minute: any, period: string): string {
            if (this.use24hr) {
                const h = hour < 10 ? "0" + hour : hour.toString();
                return h + ":" + minute;
            }
            return hour + ":" + minute + period;
        }

        selectRecurringFrequency(val: string): void {
            this.recurring.frequency = val;
        }

        getDatesForMonth(): Array<any> {
            let month = this.recurring.month;
            let days: number;
            if (month == "February") {
                days = 28;
            } else if (
                month == "September" ||
                month == "April" ||
                month == "June" ||
                month == "November"
            ) {
                days = 30;
            } else {
                days = 31;
            }
            return Array.from({ length: days }, (_, i) => i + 1);
        }

        toggleDay(value: number): void {
            let index = this.recurring.days.indexOf(value);

            if (index === -1) {
                this.recurring.days.push(value);
            } else {
                this.recurring.days.splice(index, 1);
            }
        }

        timeChanged(
            obj: any,
            period: string,
            hour: number,
            minute: number
        ): void {
            if (this.use24hr) {
                obj.hours = hour;
                obj.minutes = minute;
                obj.period = "";
            } else {
                if (hour === 12) {
                    hour = 0;
                }
                if (period === "pm" && hour < 13) {
                    hour = hour + 12;
                }
                obj.hours = hour;
                obj.minutes = minute;
                obj.period = period;
            }

            this.autoSwitchTime();
        }

        autoSwitchTime(): void {
            if (
                !this.isTimeAllowed(
                    this.recurring.end.period,
                    this.recurring.end.hours,
                    this.recurring.end.minutes
                )
            ) {
                this.recurring.end = _.cloneDeep(this.recurring.start);
                this.recurring.end.hours += 1;

                if (this.use24hr) {
                    if (this.recurring.end.hours >= 24) {
                        this.recurring.end.hours = 0;
                    }
                    this.recurring.end.model = this.formatTimeOption(
                        this.recurring.end.hours,
                        this.recurring.end.minutes,
                        ""
                    );
                } else if (this.recurring.end.period === "pm") {
                    this.recurring.end.model =
                        this.recurring.end.hours -
                        12 +
                        ":" +
                        this.recurring.end.minutes +
                        this.recurring.end.period;
                } else {
                    this.recurring.end.model =
                        this.recurring.end.hours +
                        ":" +
                        this.recurring.end.minutes +
                        this.recurring.end.period;
                }
            }
        }

        isTimeAllowed(period: string, hours: number, minutes: number): boolean {
            let start = _.cloneDeep(this.recurring.start);
            let end = _.cloneDeep(this.recurring.end);

            if (start && end) {
                if (this.use24hr) {
                    return (
                        hours > start.hours ||
                        (hours === start.hours && minutes > start.minutes)
                    );
                }

                if (hours == 12) hours = 0;
                if (start.hours == 12) start.hours = 0;

                if (period === "pm" && hours < 13) {
                    hours += 12;
                }

                if (start.period === "pm" && start.hours < 13) {
                    start.hours += 12;
                }

                return (
                    hours > start.hours ||
                    (hours === start.hours && minutes > start.minutes)
                );
            }
        }
    },
};

angular
    .module("event")
    .component(
        RecurringDateRangeComponent.selector,
        RecurringDateRangeComponent
    );
